import React from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE_TEL, CTA_TEXT } from "../data";

export default function MobileBar() {
  return (
    <div data-testid="mobile-bar" className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 bg-[#172B38] border-t border-[#F4F1E9]/15" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <a href={`tel:${PHONE_TEL}`} data-testid="mobile-bar-call" className="flex items-center justify-center gap-2 py-4 text-[#F4F1E9] text-[0.95rem] border-r border-[#F4F1E9]/15">
        <Phone className="w-4 h-4" strokeWidth={1.5} /> Call
      </a>
      <Link to="/#schedule" data-testid="mobile-bar-schedule" className="flex items-center justify-center py-4 bg-[#F4F1E9] text-[#172B38] text-[0.95rem] font-medium">{CTA_TEXT}</Link>
    </div>
  );
}
